/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tab_ComplianceInputs */

const cs_clients_tab_compliance = /** @type {(inputs: Clients_Tab_ComplianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souhlasy`)
};

const en_clients_tab_compliance = /** @type {(inputs: Clients_Tab_ComplianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance`)
};

/**
* | output |
* | --- |
* | "Compliance" |
*
* @param {Clients_Tab_ComplianceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tab_compliance = /** @type {((inputs?: Clients_Tab_ComplianceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tab_ComplianceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tab_compliance(inputs)
	return cs_clients_tab_compliance(inputs)
});